/**
 * Сито и студия — одно значение на два экрана. Сито «не стоит» = `null`,
 * профиль «не спрашиваем» = 0.
 */
import type { Filters } from '../filters';
import type { Profile } from '../profile';

type SieveKey = 'roiMin' | 'roiMax' | 'ageMax';
type ProfileKey = 'minRoi' | 'maxRoi' | 'hardKill';

export const SYNC_KEYS: readonly (readonly [SieveKey, ProfileKey])[] = [
  ['roiMin', 'minRoi'],
  ['roiMax', 'maxRoi'],
  ['ageMax', 'hardKill'],
];

export function profilePatchFromSieve(f: Partial<Pick<Filters, SieveKey>>): Partial<Profile> {
  const out: Partial<Record<ProfileKey, number>> = {};
  for (const [sieve, profile] of SYNC_KEYS) {
    if (!(sieve in f)) continue;
    out[profile] = f[sieve] ?? 0;
  }
  return out;
}

export function sievePatchFromProfile(p: Partial<Profile>): Partial<Filters> {
  const out: Partial<Record<SieveKey, number | null>> = {};
  for (const [sieve, profile] of SYNC_KEYS) {
    const value = p[profile];
    if (typeof value !== 'number') continue;
    out[sieve] = value === 0 ? null : value;
  }
  return out;
}

/** Студия открывается с тем, что сейчас режет ленту: стоящее сито побеждает. */
export function withSieve(profile: Profile, f: Pick<Filters, SieveKey>): Profile {
  const next = { ...profile };
  for (const [sieve, key] of SYNC_KEYS) {
    const value = f[sieve];
    if (value !== null) next[key] = value;
  }
  return next;
}

/** Только ручки, которые человек тронул в студии. */
export function profileDiff(before: Profile, after: Profile): Partial<Profile> {
  const out: Record<string, unknown> = {};
  for (const key of Object.keys(after) as (keyof Profile)[]) {
    if (JSON.stringify(before[key]) !== JSON.stringify(after[key])) out[key] = after[key];
  }
  return out as Partial<Profile>;
}
